import { Coffee } from "lucide-react";
import { type FormEvent, useState } from "react";
import { Button, Card, Spinner } from "../components/ui/primitives";
import { api, unwrap } from "../lib/api";

export function LoginPage({ onSuccess }: { onSuccess: () => void }) {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await unwrap(await api.auth.login.$post({ json: { passcode } }));
      onSuccess();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid h-full place-items-center bg-espresso px-4">
      <Card className="w-full max-w-sm p-6">
        <div className="mb-5 flex items-center gap-3">
          <span className="grid size-11 place-items-center rounded-xl bg-espresso text-foam">
            <Coffee className="size-5" />
          </span>
          <div>
            <h1 className="text-lg font-semibold">Café Alborada</h1>
            <p className="text-sm text-roast/80">Tu copiloto de negocio</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <label className="block text-sm font-medium" htmlFor="passcode">
            Código de acceso
          </label>
          <input
            id="passcode"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            className="w-full rounded-xl border border-latte bg-white px-3 py-2.5 outline-none focus:border-caramel focus:ring-2 focus:ring-caramel/30"
          />
          {error && (
            <p role="alert" className="text-sm text-red-700">
              {error}
            </p>
          )}
          <Button type="submit" className="w-full" disabled={!passcode || loading}>
            {loading ? <Spinner /> : "Entrar"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
